import { render } from "./BaseButton.vue?vue&type=template&id=d322e5d6&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-d322e5d6"

export default script